import axios from "axios";

const KEY = "AIzaSyBVk5nMy_-yJpDgmb0aoQ1sxYIXTHEhKtg";

export default axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3",
  params: {
    part: "snippet",
    type: "video",
    maxResults: 5,
    key: KEY,
  },
});
